<template>
  <div class="estimate-search-list">
    <article
      v-for="(bike, i) in bikeList"
      :key="`estimate-search-list__bike${i}`"
      :id="`estimate-search-list__bike${i}`"
      class="estimate-search-list__bike"
    >
      <a @click="onClick(bike.product_id)">
        <figure class="estimate-search-list__bike-img">
          <img
            :src="bike.image"
            :alt="bike.product_name"
            loading="lazy"
          >
        </figure>
        <h4 class="estimate-search-list__bike-title">
          {{ bike.product_name }}
          <span
            v-for="note in bike.notes"
            v-show="note.type == 'name'"
            v-html="`<sup>*${note.key}</sup>`"
          />
        </h4>

        <p class="estimate-search-list__bike-caption" v-text="bike.text" />

        <p class="estimate-search-list__bike-price">
          <span>現金販売価格：</span>{{ bike.price_min.toLocaleString() }}円{{ priceRange(bike.price_min, bike.price_max) }}
          <span
            v-for="note in bike.notes"
            v-show="note.type == 'price'"
            v-html="`<sup>*${note.key}</sup>`"
          />
        </p>
      </a>
    </article>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { Util } from '../master.js'

export default defineComponent({
  name: 'EstimateSearchList',
  components: {},
  props: {
    bikeList: {
      type: Array,
      required: true,
      default: () => []
    },
    selectDisplacement: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    // 排気量チェック
    // selectDisplacement内に引数のdisplacementが含まれているかを返す
    const checkDisplacement = (displacement) => {
      console.log(displacement)
      return props.selectDisplacement.includes(displacement)
    }

    const priceRange = (min, max) => {
      return min != max ? '〜' : ''
    }

    const onClick = (id) => {
      localStorage.removeItem(`estimateResult-${id}`)
      location.href = `./option?id=${id}`
    }

    return {
      checkDisplacement,
      priceRange,
      onClick,
      displacements: Util.ESTIMATE.DISPLACEMENT
    }
  }
})

</script>